module.exports = __webpack_public_path__ + "img/m_bg.1811a0d1.png";